import React from 'react'
import { Link } from 'react-router-dom'
import JoinCommunityButton from '~/common/JoinCommunityButton'
import '@css/pages/feed/RecommendedCommunityItem.scss'
import { SizeBreakpoint, useWindowSize } from '~/common/hooks/useWindowSize'
import { elementClicked } from '~/common/EventLogger'
import { GetRecommendedCommunityItemDocument } from '~/api/generated/graphql'
import { useQuery } from '@apollo/client'

type RecommendedCommunityItemProps = {
  communityId: string
  showOverlay?: boolean
  linkToCommunity?: boolean
  onJoin?: () => void
}

const RecommendedCommunityItem = ({
  communityId,
  showOverlay = true,
  linkToCommunity = true,
  onJoin,
}: RecommendedCommunityItemProps) => {
  const { breakpoint } = useWindowSize()
  const isCondensed = breakpoint <= SizeBreakpoint.md

  const { data } = useQuery(GetRecommendedCommunityItemDocument, { variables: { id: communityId }, skip: !communityId })
  const community = data?.community
  const isCompany = Boolean(data?.community?.companyId)
  // only public communities can be recommended but for joined communities we may see the user's homepage
  const link = isCompany ? `/companies/${data?.community?.companyId}` : `/communities/${communityId}`

  if (!community) return <></>

  return (
    <div className={`recommended-item-container ${isCondensed ? 'condensed' : ''}`}>
      {linkToCommunity ? (
        <Link to={link} className={'photo-container'}>
          <div
            className={'profile-photo community-photo'}
            style={community.photo ? { backgroundImage: `url(${community.photo})` } : {}}
          />
        </Link>
      ) : (
        <div className={'photo-container'}>
          <div
            className={'profile-photo community-photo'}
            style={community.photo ? { backgroundImage: `url(${community.photo})` } : {}}
          />
        </div>
      )}
      <div className="community-info">
        {linkToCommunity ? (
          <Link
            onClick={e =>
              elementClicked(e, 'click-feed-recommended-community', {
                community_id: community.communityId,
              })
            }
            to={link}
            className="community-name"
          >
            {community.name}
          </Link>
        ) : (
          <div className="community-name">{community.name}</div>
        )}
        <p className="community-description">{community.description}</p>
      </div>
      <JoinCommunityButton
        communityId={communityId}
        communityName={community.name}
        isOnHomeFeed={true}
        showOverlay={showOverlay}
        logJoinClicked={(_, e) => elementClicked(e, 'click-feed-recommended-communities-join', { communityId })}
        onActionCompleted={onJoin}
      />
    </div>
  )
}

export default RecommendedCommunityItem
